import React from "react";
import clsx from "clsx";
import NumberSpinner from "../../NumberSpinner/NumberSpinner";
import AuthenticationStatusViewer from "../../AuthenticationStatusViewer/AuthenticationStatusViewer";
import TextStatusViewer from "../../TextStatusViewer/TextStatusViewer";
import DatePickerInput from '../../DatePickerInput/DatePickerInput';
import DateHelper from "../../DateHelper/DateHelper";
import FileUploadGroupBuilder from "../../FileUploadGroupBuilder/FileUploadGroupBuilder";
import { subYears } from 'date-fns';
/* global google */

class CustomerBuilderGeneralTab extends React.Component {
  constructor(props) {
    super(props)
    this.autocompleteInput = React.createRef();
    this.autocomplete = null;
    this.handlePlaceChanged = this.handlePlaceChanged.bind(this);
    this.onChangeDate = this.onChangeDate.bind(this);
  }

  /*** Lifecycle Methods ***/

  async componentDidMount() {
    this.autocomplete = await new google.maps.places.Autocomplete(this.autocompleteInput.current,
        {"types": ["address"]});
    this.autocomplete.addListener('place_changed', this.handlePlaceChanged);
  }

  /*** Render Functions ***/

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'general',
      'tab-pane': true,
    });

    return(
      <div className={tabClasses}>
				{this.renderGeneralHeaderErrors()}
				{this.renderForm()}
      </div>
    )
  }

	renderForm() {
    return (
      <div>
        <div className="row">
          <div className="col-sm-1">
            <div className="form-group">
              <label>{I18n.t('salutation')}</label>
              <input type="text" name="customer[salutation]" value={this.props.customer && this.props.customer.salutation ? this.props.customer.salutation : ''} autoComplete="new-password" className="form-control" onChange={this.props.onChange} />
            </div>
          </div>

          <div className="col-sm-4">
            <div className="form-group">
              <label>{I18n.t('first_name')}*</label>
                <input type="text" name="customer[first_name]" value={this.props.customer && this.props.customer.first_name ? this.props.customer.first_name : ''} className={this.props.errors && this.props.errors.general_tab_field_errors && this.props.errors.general_tab_field_errors['first_name'] ? "form-control has-errors" : "form-control"} onChange={this.props.onChange} />
                {this.renderFieldErrors('first_name')}     
            </div>
          </div>

          <div className="col-sm-3">
            <div className="form-group">
              <label>{I18n.t('middle_name')}</label>
              <input type="text" name="customer[middle_name]" value={this.props.customer && this.props.customer.middle_name ? this.props.customer.middle_name : ''} autoComplete="new-password" className="form-control" onChange={this.props.onChange} />
            </div>
          </div>

          <div className="col-sm-4">
            <div className="form-group">
              <label>{I18n.t('last_name')}*</label>
              <input type="text" name="customer[last_name]" value={this.props.customer && this.props.customer.last_name ? this.props.customer.last_name : ''} autoComplete="new-password" className={this.props.errors && this.props.errors.general_tab_field_errors && this.props.errors.general_tab_field_errors['last_name'] ? "form-control has-errors" : "form-control"} onChange={this.props.onChange} />
              {this.renderFieldErrors('last_name')}
            </div>
          </div>

        </div>

        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{I18n.t('email_address')}</label>
                <input type="text" name="customer[email]" value={this.props.customer && this.props.customer.email ? this.props.customer.email : ''} autoComplete="new-password" className={this.props.errors && this.props.errors.general_tab_field_errors && this.props.errors.general_tab_field_errors['email'] ? "form-control has-errors" : "form-control"} onChange={this.props.onChange} />
              {this.renderFieldErrors('email')}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{I18n.t('mobile_number')}*</label>
              <input type="text" name="customer[formatted_phone]" value={this.props.customer && this.props.customer.formatted_phone ? this.props.customer.formatted_phone : ''} autoComplete="new-password" className={this.props.errors && this.props.errors.general_tab_field_errors && this.props.errors.general_tab_field_errors['phone_number'] ? "form-control has-errors" : "form-control"}  onChange={this.props.onChange} />
              {this.renderFieldErrors('phone_number')}
            </div>
          </div>

        </div>

        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{I18n.t('address_1')} </label>
              <input  type="text" id="autocomplete" name="customer[address_1]" value={this.props.customer && this.props.customer.address_1 ? this.props.customer.address_1 : ''} autoComplete="new-password" className="form-control" onChange={this.props.onChange} />
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group">
              <label>{I18n.t('address_2')}</label>
              <input type="text" name="customer[address_2]" value={this.props.customer && this.props.customer.address_2 ? this.props.customer.address_2 : ''} autoComplete="new-password" className="form-control" onChange={this.props.onChange} />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-3">
            <div className="form-group">
              <label>{I18n.t('city')} </label>
              <input type="text" name="customer[city]" value={this.props.customer && this.props.customer.city ? this.props.customer.city : ''} autoComplete="new-password" className="form-control" onChange={this.props.onChange} />
            </div>
          </div>

          <div className="col-sm-3">
            <div className="form-group">
              <label>{I18n.t('state_province')} </label>
              <input type="text" name="customer[state]" value={this.props.customer && this.props.customer.state ? this.props.customer.state : ''} autoComplete="new-password" className="form-control" onChange={this.props.onChange} />
            </div>
          </div>

          <div className="col-sm-3">
            <div className="form-group">
              <label>{I18n.t('postal_code')} </label>
              <input type="text" name="customer[postal_code]" value={this.props.customer && this.props.customer.postal_code ? this.props.customer.postal_code : ''} autoComplete="new-password" className="form-control" onChange={this.props.onChange} />
            </div>
          </div>

          <div className="col-sm-3">
            <div className="form-group">
              <label>{I18n.t('country')} </label>
              <input type="text" name="customer[country]" value={this.props.customer && this.props.customer.country ? this.props.customer.country : ''} autoComplete="new-password" className="form-control" onChange={this.props.onChange} />
            </div>
          </div>
        </div>

        {this.renderForms()}

        <div className="row">
          <div className="col-sm-6">
            <div className="form-group">
              <label>{I18n.t('status')}</label>
              <br />
              {
                this.props.read_only || (this.props.owner && !this.props.modifying_self)
                ?
                <div style={{ textTransform: 'capitalize' }}>{this.props.status}</div>
                :
                (
                !this.props.invitation_accepted_at
                ?
                <div>{I18n.t('inactive')}</div>
                :
                <select name="customer[status]" value={this.props.invitation_accepted_at && this.props.customer.status ? this.props.customer.status : 'inactive'} onChange={this.props.onChange} className="form-control"  style={{ width: 'auto', margin: 0 }}>
                  <option value="active">{I18n.t('active')}</option>
                  <option value="inactive">{I18n.t('inactive')}</option>
                </select>
                )
              }
            </div>
          </div>

					<div className="col-sm-6">
            <div className="form-group">
              <label>{I18n.t('marketing_opt_in')}</label>
              <select name="customer[marketing_opt_in]" className="form-control" style={{ width: 'auto', margin: 0 }} value={this.props.customer && this.props.customer.marketing_opt_in ? this.props.customer.marketing_opt_in : false} onChange={this.props.onChange}>
                <option value={false}>{I18n.t('no')}</option>
                <option value={true}>{I18n.t('yes')}</option>
              </select>
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='col-sm-6'>
            {this.props.customer.id ? <AuthenticationStatusViewer {...this.props} email={this.props.customer && this.props.customer.email ? this.props.customer.email : ''} /> : null}
          </div>
          <div  className='col-sm-6'>
            {this.props.customer.id && this.props.enable_messaging ? <TextStatusViewer {...this.props} phone_number={this.props.customer && this.props.customer.formatted_phone ? this.props.customer.formatted_phone : ''} /> : null}
          </div>
        </div>
      </div>
    );
  }

  renderForms() {
    if(this.props.forms) {
      var title = ""
      var forms = this.props.forms.map((form, idx) => {
        if(form.no_fields != true) {
          form.map((form_field) => {
             title = form_field.form_title
          })
        } else {
          title = form.form.title
        }
        return (
          <fieldset className="field-group" key={idx}>
              <legend>{title}</legend>
              { form.no_fields != true ? this.renderFormFields(form) : null}
          </fieldset>
        )
      })
      return (
        <div>
          {forms}
        </div>
      )
    }
  }

  renderFormFields(form) {
    var formFields = form.map((form_field, idx) => {
      var form_field_answer = null
      var number_field_answer = null
      var date_field_answer = null
      var address_field_answer = null
      if(this.props.answers) {
        var customerAnswers = this.props.answers
        customerAnswers.map((answer) => {
          if(answer.form_field_id == form_field.id){
            if(answer.number_answer) {
              number_field_answer = answer.number_answer
            } else if(answer.date_answer) {
              date_field_answer = answer.date_answer
            } else if(answer.upload_file_name != null) {
              form_field_answer = answer         
            } else if(answer.formatted_address) {
              address_field_answer = answer.formatted_address 
            } else {
              form_field_answer = answer.answer
            }
          }
        })
      }
      var customerFieldOptions = form_field.options.map((form_field_option, index) => {
        return <option key={index} value={form_field_option.option}>{form_field_option.option}</option>
      })

      if(form_field.field_type == "text_field_single_line") {
        return (
          <div className="row" key={idx}>
            <div className="col-lg-6">
              <div className="form-group">
                <label style={{whiteSpace: "pre-wrap", paddingBottom: "5px"}}>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
                <input className={this.props.errors && this.props.errors.general_tab_field_errors && this.props.errors.general_tab_field_errors[form_field.field] ? "form-control has-errors" : "form-control"} name={form_field.id} id={form_field.id} value={form_field_answer ? form_field_answer : ""} onChange={this.props.onChangeFormFields}  />
                {this.renderFieldErrors(form_field.field)}
              </div>
            </div>
          </div>
        )
      }

      if(form_field.field_type == "select_box") {
        return (
          <div className="row" key={idx}>
            <div className="col-lg-6">
              <div className="form-group ">
                <label style={{whiteSpace: "pre-wrap", paddingBottom: "5px"}}>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
                <select className={this.props.errors && this.props.errors.general_tab_field_errors && this.props.errors.general_tab_field_errors[form_field.field] ? "form-control has-errors" : "form-control"} name={form_field.id} id={form_field.id} value={form_field_answer ? form_field_answer : "please_select_one"} onChange={this.props.onChangeFormFields} >
                  <option value="please_select_one">{I18n.t("select_ellipsis")}</option>
                  {customerFieldOptions}
                </select>
                {this.renderFieldErrors(form_field.field)}
              </div>
            </div>
          </div>
        )
      }

      if(form_field.field_type == "number_input") {
        return (
          <div className='row' key={idx}>
            <div className="col-lg-6">
              <div className="form-group">
                <label style={{whiteSpace: "pre-wrap", paddingBottom: "5px"}}>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
                <NumberSpinner
                  name='number'
                  id={form_field.id}
                  onChange={this.props.onChangeFormFields}
                  value={number_field_answer ?  number_field_answer : ""}
                  hasError={this.renderFieldClasses(form_field.field, true)}/>
                {this.renderFieldErrors(form_field.field, true)}
              </div>
            </div>
          </div>
        )
      }

      if(form_field.field_type == "date_form_field") {
        date_field_answer && typeof date_field_answer == 'string' ? date_field_answer = DateHelper.parseDateFromBackend(date_field_answer) : null;
        return (
          <div className="row" key={idx}>
            <div className="col-lg-6">
              <div className="form-group">
                <label style={{whiteSpace: "pre-wrap", paddingBottom: "5px"}}>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
                <DatePickerInput
                  selectedDate={date_field_answer}
                  dateFormat={DateHelper.rubyToDateFNS(this.props.dateFormat)}
                  customChangeHandler={this.onChangeDate}
                  customChangeSource="FormField"
                  formFieldID={form_field.id}
                  classNames={this.props.errors && this.props.errors.general_tab_field_errors && this.props.errors.general_tab_field_errors[form_field.field] ? "form-control has-errors" : "form-control"}
                  minDate={subYears(new Date(), 100)}
                />
                {this.renderFieldErrors(form_field.field)}
              </div>
            </div>
          </div>
        )
      }

      if(form_field.field_type == "text_area_multi_line") {
        return (
          <div className="row" key={idx}>
            <div className="col-lg-6">
              <div className="form-group">
                <label style={{whiteSpace: "pre-wrap", paddingBottom: "5px"}}>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
                <textarea className={this.props.errors && this.props.errors.general_tab_field_errors && this.props.errors.general_tab_field_errors[form_field.field] ? "form-control has-errors" : "form-control"} name={form_field.id} id={form_field.id} defaultValue={form_field_answer ? form_field_answer : ""} onChange={this.props.onChangeFormFields}  />
                {this.renderFieldErrors(form_field.field)}
              </div>
            </div>
          </div>
        )
      }

      if(form_field.field_type == "phone_number") {
        return (
          <div className="row" key={idx}>
            <div className="col-lg-6">
              <div className="form-group">
              <label style={{whiteSpace: "pre-wrap", paddingBottom: "5px"}}>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
                <input type="tel" className={this.props.errors && this.props.errors.general_tab_field_errors && this.props.errors.general_tab_field_errors[form_field.field] ? "form-control has-errors" : "form-control"}  name={form_field.id} id={form_field.id} value={form_field_answer ? form_field_answer : ""} onChange={this.props.onChangeFormFields}  />
                {this.renderFieldErrors(form_field.field)}
              </div>
            </div>
          </div>
        )
      }


      
      if(form_field.field_type == "numbered_scale") {
        var current_rating_answer = []

        if(this.props.rating_answers.length > 0) {
          this.props.rating_answers.map((rating_answer) => {
            if(rating_answer.form_field_id == form_field.id) {
              current_rating_answer = rating_answer
            }
          })   
        } else {
          current_rating_answer = {
            answer: form_field_answer,
            selected: true
          }
        }
          
        return (
          <div className="row" key={idx}>
            <div className="col-lg-6">
              {/* <div className="form-group"> */}
                <label style={{whiteSpace: "pre-wrap", paddingBottom: "5px"}}>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
                {this.renderRatingRangeForm(form_field, current_rating_answer)}
                <br></br>
                {this.renderFieldErrors(form_field.field)}
              {/* </div> */}
            </div>
          </div>
        )
      }

      if(form_field.field_type == "emoji_rating") {
        var current_emoji_answer = []
        if(this.props.emoji_answers.length > 0) {
          this.props.emoji_answers.map((emoji_answer) => {
            if(emoji_answer.form_field_id == form_field.id) {
              current_emoji_answer = emoji_answer 
            }
          })  
        } else {
          current_emoji_answer = {
            answer: form_field_answer,
            selected: true
          }
        }
        return (
          <div className="row" key={idx}>
            <div className="col-lg-6">
              {/* <div className="form-group" style={{paddingBottom: "30px"}}>        */}
                <label style={{whiteSpace: "pre-wrap", paddingBottom: "5px"}}>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
                {this.renderEmojiRatingForm(form_field, current_emoji_answer)}
                <br></br>
                {this.renderFieldErrors(form_field.field)}
              {/* </div> */}
            </div>
          </div>
        )
      }

      if(form_field.field_type == "signature_generator") {
        if(form_field_answer) {
          return (
            <div className="col-lg-6" key={form_field.id}>
              <div className="form-group">
                <label>{I18n.t('signature_generator')}*</label>
                <input className={this.props.errors && this.props.errors.field_errors && this.props.errors.field_errors[form_field.field] ? "form-control has-errors" : "form-control"} name={form_field.id} id={form_field.id} value={form_field_answer ? form_field_answer : ""} onChange={this.props.onChangeFormFields}  />
                <br></br>
                <textarea className={this.props.errors && this.props.errors.field_errors && this.props.errors.field_errors[form_field.field] ? "form-control signature-generator has-errors" : "form-control signature-generator"} name={form_field.id} id={form_field.id} value={form_field_answer ? form_field_answer : ""} style={{fontFamily: 'cursive'}} readOnly={true}/>
              </div>
            </div>
          )
        } else {
          return (
            <div className="col-lg-6" key={form_field.id}>
              <div className="form-group">
                <label>{I18n.t('signature_generator')}*</label>
                <input className={this.props.errors && this.props.errors.field_errors && this.props.errors.field_errors[form_field.field] ? "form-control has-errors" : "form-control"} name={form_field.id} id={form_field.id} value={form_field_answer ? form_field_answer : ""} onChange={this.props.onChangeFormFields}  />
              </div>
            </div>
          )
        } 
      }
      if(form_field.field_type == "image") {
        return(
          <div className="col-lg-6" key={form_field.id} style={{padding:'0'}}>
            <FileUploadGroupBuilder nested={true} read_only={false} onChange={this.props.onChangeFormFieldFileUploadGroup ? this.props.onChangeFormFieldFileUploadGroup : this.onChangeFormFieldFileUploadGroup} file_upload_groups={this.props.customer_file_upload_group ? [this.props.customer_file_upload_group] : [{ file_uploads: [form_field_answer] }]} singleFile={true} form_field_id={form_field.id} />
          </div>   
        )
      }
      
      if(form_field.field_type == "address") {
        return (
          <div className="row" key={idx}>
            <div className="col-lg-6">
              <div className="form-group">
                <label>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
                <input  
                  type="text" 
                  id={form_field.id}
                  ref={this.autocompleteInput} 
                  name="answers[formatted_address]" 
                  value={address_field_answer ?  address_field_answer : ""}
                  autoComplete="new-password" 
                  className={this.props.errors && this.props.errors.general_tab_field_errors && this.props.errors.general_tab_field_errors[form_field.field] ? "form-control has-errors" : "form-control"}
                  onChange={(e) => this.props.onChangeAddress(form_field.id, e)}/>
                {this.renderFieldErrors(form_field.field)}
              </div>
            </div>
          </div>
        )
      }
    });
    return (
      <div>
        {formFields}
      </div>
    );
  }




 renderEmojiRatingForm(form_field, current_emoji_answer) {
    var rating_range = 5
    var rating_range_arr = []

    for(let index = 0; index < rating_range; index++) {
      rating_range_arr.push(index + 1)  
    }

    var rating_range_lines = rating_range_arr.map((rating) => {
    
      if(rating_range == 5) {
        if(rating == 1) {
          var list_emoji = <i className="far fa-frown-open fa-2x"></i>
        }
        else if(rating == 2) {

          var list_emoji = <i className="far fa-frown fa-2x"></i>
           
        } else if (rating == 3) {

          var list_emoji = <i className="far fa-meh fa-2x"></i>

        } else if (rating == 4) {

          var list_emoji = <i className="far fa-smile fa-2x"></i>
          
        } else {

          var list_emoji = <i className="far fa-grin fa-2x"></i>

        } 
      
      }
      
      return (
        <li className={rating == current_emoji_answer.answer && current_emoji_answer.selected == true  ? `selected-emoji-scale-li` : `emoji-scale-li`}  onClick={() => this.props.onChangeSelectedEmoji(rating, form_field)} key={rating}>{list_emoji}</li>
      )
    })
  
  if(this.props.rating_range != 'none') {

    return (
      <ul className="emoji-scale-ul">
        {rating_range_lines}
      </ul>
    )
  } 

}


renderRatingRangeForm(form_field, current_rating_answer) {
  if(form_field) {
    var rating_range = parseInt(form_field.rating_scale.rating_range, 10)
    var rating_range_arr = []
    for(let index = 0; index < rating_range; index++) {
      rating_range_arr.push(index + 1)  
    }
    var rating_range_lines = rating_range_arr.map((rating) => {
      if(rating_range == 10) {

        if(rating <= 3){
          var color = "#aa381d"
        } else if (rating > 3 && rating <= 6) {
          var color = "#d18140"
        } else if (rating > 3 && rating <= 6) {
          var color = "#bba350"
        } else {
          var color = "#61a544"
        }
      }

      if(rating_range == 5) {
        if(rating < 3){
          var color = "#aa381d"
        } else if (rating  == 3) {
          var color = "#bba350"
        } else if (rating > 3 && rating <= 6) {
          var color = "#61a544"
        } else {
          var color = "#61a544"
        }

      }
      
      return (
        <li className={rating == current_rating_answer.answer && current_rating_answer.selected == true ? "selected-rating-scale-li" : "rating-scale-li"}  onClick={() => this.props.onChangeSelectedRating(rating, form_field)} key={rating} style={{borderColor: color, color:color}}>{rating}</li>
      )
    })
  }
    if(this.props.rating_range != 'none') {

      return (
        <ul className="rating-scale-ul">
          {rating_range_lines}
        </ul>
      )
    } 
  }

   /*** Error Handling ***/

  renderFieldErrors(key, numberSpinner) {
    if (this.props.errors && this.props.errors.general_tab_field_errors && this.props.errors.general_tab_field_errors[key]) {
      var error = this.props.errors.general_tab_field_errors[key][0]
      if(numberSpinner == true) {
        return (
          <div className="help-block">
            <ul><li style={{textAlign: "left"}}><b>&#x2022;</b>{error}</li></ul>
          </div>
        );

      } else {

        return (
          <div className="help-block">
            <ul><li><b>&#x2022;</b>{error}</li></ul>
          </div>
        );
      };
    };

  }

  renderGeneralHeaderErrors() { 
    if (this.props.errors && this.props.errors.general_tab_header_errors) {
      var errors = this.props.errors.general_tab_header_errors.map((error, idx) => <li key={idx}>{error}</li>)
      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    };
  }

  renderFieldClasses(field, noFormControl) {
    if (noFormControl === true) {
      var classname = ''
    } else {
      var classname = 'form-control';
    }
    if(this.props.errors && this.props.errors.general_tab_header_errors){

      this.props.errors.general_tab_header_errors.forEach((error) => {
        if (error == `${this.capitalizeFirstLetter(field)} can't be blank `) {
          classname = classname + ' has-errors'   
        }
      })   
      return classname
    }
  }


  /*** Helper Methods ***/

  onChangeDate(date, id) {
    this.props.onChangeFormFields({
      target: {
        name: 'date',
        value: date,
        id: id
      }
    });
  }

  capitalizeFirstLetter(str) {
		return str.charAt(0).toUpperCase() + str.slice(1);
  }

  handlePlaceChanged() {
    var addressObject = this.autocomplete.getPlace()
    var address = addressObject.address_components
    var answers = this.props.answers
    var form_field_address_field_id = this.props.form_field_address_field_id

    for(let i = 0; i < address.length; i++){
      for(let j = 0; j < address[i].types.length; j++){
        if(address[i].types[j] === "street_number") {
          var street_number = address[i].long_name
        }
        if(address[i].types[j] === "route") {
          var route = address[i].long_name
        }
        if(address[i].types[j] === "locality") {
          var city = address[i].long_name
        }
        if(address[i].types[j] === "administrative_area_level_1") {
          var state_province = address[i].long_name
        }
        if(address[i].types[j] === "postal_code") {
          var postal_code = address[i].long_name
        }
        if(address[i].types[j] === "country") {
          var country = address[i].long_name
        }
      }
    }

    var newAddressObject = {
      address_1: street_number ? `${street_number} ${route}` : route,
      formatted_address: addressObject.formatted_address,
      city: city,
      state: state_province,
      country: country,
      postal_code: postal_code,
      form_field_id: form_field_address_field_id
    }

    this.props.forms.map((group) => {
      group.map((field) => {
        if(field.id === newAddressObject.form_field_id) {
          var found = false;
          if(answers) {
            for(var i = 0, ilen = answers.length; i < ilen; i++) {
              if (answers[i].form_field_id === newAddressObject.form_field_id) {
                found = true;
                break;
              }
            }
          }
          if (found) {
            answers.map((answer, idx) => {
              if (answer.form_field_id === newAddressObject.form_field_id) {
                answers[idx] = newAddressObject    
              }
            })
          } else {
            if(!answers) {
              answers = []
            }
            var new_answer = newAddressObject
            answers.push(new_answer)
          }
        }
      })
    })
    this.props.handlePlaceSelect(answers)
  }

}

export default CustomerBuilderGeneralTab
